/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { PluginSidebar, PluginSidebarMoreMenuItem } from '@wordpress/edit-post';
import { registerPlugin } from '@wordpress/plugins';
import { PanelBody, PanelRow, Button, Slot, Fill, Icon } from '@wordpress/components';
import { useState } from '@wordpress/element';

/**
 * Inner dependencies.
 */
import Templates from './templates';
import './toolbar-templates-button';
import { GutenifyLogo as icon } from '../../components/Icons';
import CustomizerPanel from '../../components/customizer-panel/index.js';

const Component = () => {
	const [ { isTemplatesOpen, isCustomizerPanelOpen }, setState ] = useState( {
		isTemplatesOpen: false,
		isCustomizerPanelOpen: false,
	} );
	const openModal = () => setState( {
		isTemplatesOpen: true,
	} );
	const closeModal = () => setState( {
		isTemplatesOpen: false,
	} );

	const openCustomizerPanel = () => setState( {
		isCustomizerPanelOpen: true,
	} );
	const closeCustomizerPanel = () => setState( {
		isCustomizerPanelOpen: false,
	} );

	const MyPanelSlot = ( props ) => (
		<Fill name="MyPanelSlot">{ props.children }</Fill>
	);

	MyPanelSlot.slot = () => (
		<PanelBody>
			<Slot name="MyPanelSlot" bubblesVirtually={ true } />
		</PanelBody>
	);

	return <>
		{ isTemplatesOpen && <Templates onRequestClose={ () => {
			closeModal();
		} } /> }
		{ /* <MyPanelSlot>Welcome</MyPanelSlot> */ }
		<PluginSidebarMoreMenuItem target="gutenify-sidebar">
			{ __( 'Gutenify Options' ) }
		</PluginSidebarMoreMenuItem>
		<PluginSidebar name="gutenify-sidebar" title={ __( 'Gutenify Options' ) } icon={ icon }>
			<PanelBody>
				<PanelRow className="gutenify--flex gutenify--flex--justify-center">
					<Button onClick={ () => openModal() } variant="primary"><Icon icon={ 'grid-view' } size={ 16 } /> &nbsp; { __( 'Template Browser' ) }</Button>
				</PanelRow>
				{ /* <Button onClick={ () => openCustomizerPanel() } variant="primary">{ __( 'Customize' ) }</Button> */ }
				{ /* { isCustomizerPanelOpen && <CustomizerPanel onClose={ closeCustomizerPanel } /> } */ }
				{ /* <MyPanelSlot.slot /> */ }
			</PanelBody>
		</PluginSidebar>
	</>;
};

registerPlugin( 'gutenify', {
	icon,
	render: Component,
} );
